// FeaturedUniversities.js — P10 section 7. Six cards from /api/universities/,
// explicitly curated by staff via each university's "Featured" checkbox
// (UniversityForm.js) rather than an arbitrary alphabetical slice — see the
// is_featured field on the University model. Renders nothing when no
// university is marked featured.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getUniversities } from '../services/api';
import './FeaturedUniversities.css';

export default function FeaturedUniversities() {
  const [universities, setUniversities] = useState([]);

  useEffect(() => {
    getUniversities({ featured: 'true', limit: 6 })
      .then((data) => {
        const list = Array.isArray(data) ? data : (data.results || []);
        setUniversities(list.slice(0, 6));
      })
      .catch(() => {});
  }, []);

  if (universities.length === 0) return null;

  return (
    <section className="featured-unis-section" aria-labelledby="featured-unis-heading">
      <div className="featured-unis-container">
        <div className="featured-unis-header">
          <h2 id="featured-unis-heading" className="featured-unis-title">Partner universities</h2>
          <p className="featured-unis-subtitle">A sample of the institutions our students are placed at.</p>
          <Link to="/universities" className="featured-unis-all-link">View all universities →</Link>
        </div>

        <div className="featured-unis-grid">
          {universities.map((u) => (
            <Link key={u.id} to={`/universities/${u.slug}`} className="featured-uni-card">
              <div className="featured-uni-logo-wrap">
                {u.logo_url ? (
                  <img
                    src={u.logo_url}
                    alt={`${u.name} logo`}
                    className="featured-uni-logo"
                    width={64}
                    height={64}
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <span className="featured-uni-logo-fallback" aria-hidden="true">
                    {u.name.charAt(0)}
                  </span>
                )}
              </div>
              <h3 className="featured-uni-name">{u.name}</h3>
              {u.city && <p className="featured-uni-city">{u.city}</p>}
              {typeof u.program_count === 'number' && u.program_count > 0 && (
                <p className="featured-uni-programs">{u.program_count} program{u.program_count === 1 ? '' : 's'}</p>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
